var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.brandLogoComponent,{tag:"component",attrs:{"brand-name":_vm.brandFullName}})}
var staticRenderFns = []

export { render, staticRenderFns }